<template>
	<div
		class="hdl-text-response-word-limits"
		role="status"
		aria-live="polite"
		:class="{
			'over': enteredWords > 0 && limitMax !== null && enteredWords > limitMax,
			'under': enteredWords > 0 && limitMin !== null && enteredWords < limitMin
		}"
	>
		<template v-if="hasLimitMin && !hasLimitMax">
			{{ enteredWords }} of at least {{ limitMin }} words
		</template>
		<template v-else-if="hasLimitMax && !hasLimitMin">
			{{ enteredWords }} / {{ limitMax }} words
		</template>
		<template v-else-if="hasLimitMax && hasLimitMin">
			{{ enteredWords }} of a minimum of {{ limitMin }} and a maximum of {{ limitMax }} words
		</template>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component
export default class WordLimitsDisplay extends Vue {
	@Prop({ required: true })
	enteredWords: number;

	@Prop({ default: null })
	limitMin: number | null;

	@Prop({ default: null })
	limitMax: number | null;

	get hasLimitMin(): boolean {
		return this.limitMin !== null && this.limitMin > 0;
	}

	get hasLimitMax(): boolean {
		return this.limitMax !== null && this.limitMax > 0;
	}

	get hasWordLimits(): boolean {
		return this.hasLimitMin || this.hasLimitMax;
	}
}
</script>

<style lang="scss">
.hdl-text-response-word-limits {
	@apply text-secondary;

	&.over,
	&.under {
		@apply text-hdl-wc-red;
	}
}
</style>
